import {
	TREES__AGGREGATE_FETCH,
	TREES__AGGREGATE_FETCH_ERROR,
	TREES__AGGREGATE_RETRIEVED,
	TREES__AGGREGATE_CLEAR,
} from '../../actions/trees/aggregate';
import {AUTH__LOGOUT} from '../../actions/auth';

const INITIAL_STATE = {
	loading: false,
	error: false,
	indicators: null,
	indicatorMap: null,
	trees: null,
	treeMap: null,
	indicatorRootMap: null,
	marketFilter: '',
};

const defaultExports = function (state = INITIAL_STATE, action) {
	switch (action.type) {
		case TREES__AGGREGATE_FETCH:
			return {
				...INITIAL_STATE,
				loading: true,
			};
		case TREES__AGGREGATE_RETRIEVED:
			return {
				indicators: action.payload.indicators,
				indicatorMap: action.payload.indicatorMap,
				trees: action.payload.trees,
				treeMap: action.payload.treeMap,
				indicatorRootMap: action.payload.indicatorRootMap,
				aggregatedIndicator: action.payload.aggregatedIndicator,
				marketFilter: action.payload.marketFilter,
				loading: false,
				error: false,
			};
		case TREES__AGGREGATE_FETCH_ERROR:
			return {
				...state,
				error: action.error,
				loading: false,
			};
		case TREES__AGGREGATE_CLEAR:
			return INITIAL_STATE;
		case AUTH__LOGOUT:
			return INITIAL_STATE;
		default:
			return state;
	}
};
export default defaultExports;
